<div class="big-header" style="text-align: left; margin-bottom: 8px;">
  Hello@if (!isLoading) {
  <span>{{', ' + employee.fullName}}</span>
  }!
</div>

<app-loading-swirly [isLoading]="isLoading"></app-loading-swirly>

@if (!isLoading && assignedReports?.length > 0) {
  <div>
    <div class="p-grid">
      <div class="p-col-2">
        <h6>Start Date</h6>
        <p-datepicker
          [style]="{'width': '100%'}"
          name="filterStartDate"
          class="calendar-picker"
          [placeholder]="'Start Date'"
          [(ngModel)]="filterStartDate"
          [inputStyle]="{'width':'100%'}"
          [disabled]="isLoading"
          [maxDate]="filterEndDate"
          oninput="validity.valid||(value='');"
          [showButtonBar]="true"
          >
        </p-datepicker>
      </div>
      <div class="p-col-2">
        <h6>End Date</h6>
        <p-datepicker
          [style]="{'width': '100%'}"
          name="filterEndDate"
          class="calendar-picker"
          [placeholder]="'End Date'"
          [(ngModel)]="filterEndDate"
          [inputStyle]="{'width':'100%'}"
          [minDate]="filterStartDate"
          [disabled]="isLoading"
          oninput="validity.valid||(value='');"
          [showButtonBar]="true"
          >
        </p-datepicker>
      </div>
      @if (canViewDataAs) {
        <div class="p-col-2">
          <div class="bold">
            View Data As
          </div>
          <ng-select
            class="custom"
            required
            [searchable]="false"
            [selectOnTab]="true"
            [items]="employees"
            placeholder="Select Regional Manager"
            name="rep"
            bindLabel="fullName"
            [(ngModel)]="filterEmployee"
            [disabled]="isLoading"
            >
          </ng-select>
        </div>
      }
      <div class="p-col-2">
        <h6>&nbsp;<!-- Spacer so button is aligned with textboxes --></h6>
        <p-button label="Filter" (click)="filter()"></p-button>
      </div>
    </div>
    <div class="masonry-with-columns">
      @for (report of assignedReports; track report) {
        <span>
          @if (report.id == 1 || report.id == 9) {
            <app-completed-paid-totals class="item" [employee]="employee" [title]="report.name" [companyWide]="report.companyWide" [mainColor]="completedPaidTotalColor"></app-completed-paid-totals>
          }
          @if (report.id == 2 || report.id == 10) {
            <app-customer-issues class="item" [employee]="employee" [title]="report.name" [companyWide]="report.companyWide"></app-customer-issues>
          }
          @if (report.id == 3 || report.id == 11) {
            <app-quote-stats class="item" [employee]="employee" [title]="report.name" [companyWide]="report.companyWide"></app-quote-stats>
          }
          @if (report.id == 4 || report.id == 12) {
            <app-in-backlog class="item" [employee]="employee" [title]="report.name" [companyWide]="report.companyWide" [mainColor]="backlogTotalColor"></app-in-backlog>
          }
          @if (report.id == 5 || report.id == 13) {
            <app-past-due class="item" [employee]="employee" [title]="report.name" [companyWide]="report.companyWide" [mainColor]="pastDueColor"></app-past-due>
          }
          @if (report.id == 6 || report.id == 14) {
            <app-sales-estimate class="item" [employee]="employee" [title]="report.name" [companyWide]="report.companyWide" [backlogColor]="backlogTotalColor" [completeAndUnpaidColor]="pastDueColor" [completeAndPaidColor]="completedPaidTotalColor" [commissionLostColor]="commissionLostColor"></app-sales-estimate>
          }
          @if (report.id == 7 || report.id == 15) {
            <app-commission-lost class="item" [employee]="employee" [title]="report.name" [companyWide]="report.companyWide" [mainColor]="commissionLostColor"></app-commission-lost>
          }
          @if (report.id == 8 || report.id == 16) {
            <app-work-hour-average class="item" [employee]="employee" [title]="report.name" [companyWide]="report.companyWide" [wellnessGoal]="wellnessWorkHourAverageGoal" [workGoal]="workWorkHourAverageGoal"></app-work-hour-average>
          }
          @if (report.id == 9 || report.id == 17) {
            <app-work-to-be-completed  class="item"></app-work-to-be-completed>
          }
        </span>
      }
    </div>
  </div>
}

@if (!isLoading && assignedReports?.length == 0) {
  <div>
    You current have no reports assigned.
  </div>
}
